import JSEncrypt from "jsencrypt";

const APP_KEY = process.env.REACT_APP_SIGN_APP_KEY;
const APP_SECRET = process.env.REACT_APP_SIGN_SECRET;

async function hmacSha256Hex(secret: string, message: string): Promise<string> {
  const encoder = new TextEncoder();
  const key = await crypto.subtle.importKey(
    "raw",
    encoder.encode(secret),
    { name: "HMAC", hash: "SHA-256" },
    false,
    ["sign"]
  );
  const sig = await crypto.subtle.sign("HMAC", key, encoder.encode(message));
  return Array.from(new Uint8Array(sig))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
}

function getDeviceId(): string {
  const key = "ltsoy_device_id";
  let id = localStorage.getItem(key);
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem(key, id);
  }
  return id;
}

export async function buildSignHeaders(
  body?: Record<string, any>
): Promise<Record<string, string>> {
  const timestamp = String(Math.floor(Date.now() / 1000));
  const nonce = crypto.randomUUID().replace(/-/g, "");
  const deviceId = getDeviceId();

  const allParams: Record<string, string> = {
    appKey: APP_KEY,
    timestamp,
    nonce,
    ...Object.fromEntries(
      Object.entries(body ?? {}).map(([k, v]) => [k, String(v)])
    ),
  };

  const stringToSign = Object.keys(allParams)
    .sort()
    .map((k) => `${k}=${allParams[k]}`)
    .join("&");

  const sign = await hmacSha256Hex(APP_SECRET, stringToSign);
  return {
    appKey: APP_KEY,
    deviceId,
    nonce,
    sign,
    timestamp,
    "user-agent": "android",
  };
}

export const encryption = (publicKeyPem: any, message: any) => {
  const lines = publicKeyPem.match(/.{1,64}/g) || [];
  const _publicKeyPem = `-----BEGIN PUBLIC KEY-----\n${lines.join(
    "\n"
  )}\n-----END PUBLIC KEY-----`;
  const encrypt = new JSEncrypt();
  encrypt.setPublicKey(_publicKeyPem);
  const cipherBase64 = encrypt.encrypt(message);
  return cipherBase64;
};
export const authService = {
  login(token: string) {
    sessionStorage.setItem("token", token);
  },
  logout() {
    sessionStorage.removeItem("token");
  },
  getToken() {
    return sessionStorage.getItem("token");
  },
};
export const formatUKPhone = (rawPhone: any) => {
  if (!rawPhone) return "";
  const digits = rawPhone.replace(/\D/g, "");
  if (!digits) return "";
  let numberBody = "";
  if (digits.startsWith("44")) {
    numberBody = digits.slice(2);
  } else if (digits.startsWith("0")) {
    numberBody = digits.slice(1);
  } else if (/^[127]/.test(digits)) {
    numberBody = digits;
  } else {
    return "";
  }
  if (/^7\d{9}$/.test(numberBody)) {
    return `44 ${numberBody.slice(0, 4)} ${numberBody.slice(4)}`;
  }
  if (/^[12]\d{8,9}$/.test(numberBody)) {
    return `44 ${numberBody}`;
  }
  return "";
};
export const maskEmail = (
  email: string,
  keepPosition: "head" | "tail" = "tail"
) => {
  const emailParts = email.split("@");
  if (emailParts.length !== 2) return email;
  const [localPart, domain] = emailParts;
  const localLen = localPart.length;

  if (localLen >= 3) {
    const keepChars =
      keepPosition === "tail" ? localPart.slice(-2) : localPart.slice(0, 2);
    return `****${keepChars}@${domain}`;
  }
  if (localLen === 0) return `*@${domain}`;
  return `*${localPart}@${domain}`;
};
